package ui.app.rss.instance


import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import androidx.compose.ui.text.input.TextFieldValue
import io.Repository
import kotlinx.coroutines.launch
import tk.mallumo.compose.navigation.viewmodel.NavigationViewModel
import tk.mallumo.compose.navigation.viewmodel.VM
import tk.mallumo.utils.DataState
import tk.mallumo.utils.mutableDataState
import tools.printStackTraceInDebug

@VM
class AppRssListingInstanceVM : NavigationViewModel() {


    val searchFiled = mutableStateOf(TextFieldValue(""))

    private lateinit var scopeUi: AppRssListingInstanceScope

    var state by mutableDataState<AppRssListingInstanceScope.Wrapper>()
        private set

    fun init(scopeUi: AppRssListingInstanceScope) {
        this.scopeUi = scopeUi
        if (state !is DataState.Result) {
            state = DataState.Loading()
        }

        scope.launch {
            runCatching {
                state = DataState.Result(
                    AppRssListingInstanceScope.Wrapper(
                        Repository.api.rss.listingInstance()
                    )
                )
            }.onFailure {
                it.printStackTraceInDebug()
                state = DataState.Error(it.message!!, throwable = it)
            }
        }
    }

    override fun onRelease() {
        state.entry?.release()
        state = DataState.Idle()
    }

}
